import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.js";
import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.js";
function getDialogUtilityClass(slot) {
  return generateUtilityClass("MuiDialog", slot);
}
const dialogClasses = generateUtilityClasses("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]);
export {
  dialogClasses as default,
  getDialogUtilityClass
};
//# sourceMappingURL=dialogClasses.js.map
